// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FurnitureDetails-module__imageContainer--djwn9 {
    border-radius: 12px;
    overflow: hidden;
    max-height: 414px;
}

.FurnitureDetails-module__imageContainer--djwn9 img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.FurnitureDetails-module__imageItem--cFMkz {
    border-radius: 12px;
    overflow: hidden;
    max-width: 96px;
    cursor: pointer;
}

.FurnitureDetails-module__imageItem--cFMkz img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.FurnitureDetails-module__imageItem--cFMkz.FurnitureDetails-module__selected--z3bnF {
    border: 2px solid var(--color-general-black);
}
`, "",{"version":3,"sources":["webpack://./src/dom/Demo/SelectFurniture/FurnitureDetails.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,4CAA4C;AAChD","sourcesContent":[".imageContainer {\n    border-radius: 12px;\n    overflow: hidden;\n    max-height: 414px;\n}\n\n.imageContainer img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.imageItem {\n    border-radius: 12px;\n    overflow: hidden;\n    max-width: 96px;\n    cursor: pointer;\n}\n\n.imageItem img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.imageItem.selected {\n    border: 2px solid var(--color-general-black);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"imageContainer": `FurnitureDetails-module__imageContainer--djwn9`,
	"imageItem": `FurnitureDetails-module__imageItem--cFMkz`,
	"selected": `FurnitureDetails-module__selected--z3bnF`
};
export default ___CSS_LOADER_EXPORT___;
